import React from 'react'
import { useParams } from 'react-router-dom'
import styles from './StateHeader.module.scss'
import Content from '../../../components/Content'
import Layout from '../../../components/Layout'
import GeoProvider from '../../../components/GeoProvider'
import DashboardMap from './DashboardMap'
import dataDisplayOptions from '../dataDisplayOptions'
import { startDate, endDate, displayDate } from '../dates'
import Header from './Header'
import Gender from './../GenderAgePanel'
import SystemNotification from './../../Dashboard/SystemNotification'
const UTIZip3Dashboard = () => {
  const { geo_parent,area, loc } = useParams()
  return (
    <Layout>
      <Content>
        <div className={styles.base}>
          <div className={styles.body}>
            <GeoProvider
              startDate={startDate}
              endDate={endDate}
              displayDate={displayDate}
              mapOptions={dataDisplayOptions[0]['options'][0]}
              indicatorName={dataDisplayOptions[0]['options'][0].indicatorName}
              regionSelected={'state'}
            >
              <SystemNotification/>
              <Header headerType={area} headerNumber={2} geo_id={loc}   geo_parent={geo_parent.toUpperCase()}/>
              <DashboardMap
                geo_type={area.toUpperCase()}
                geo_parent={geo_parent.toUpperCase()}
                zoomLocation={loc.toUpperCase()}
              />
              <Gender geo_type={area} geo_id={loc} data_type="UTI" />
            </GeoProvider>
          </div>
        </div>
      </Content>
    </Layout>
  )
}

export default UTIZip3Dashboard
